import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface INotificationModalAttrs {
  isOpen: boolean;
  type?: 'success' | 'error' | undefined;
  message?: string | undefined;
  width?: string;
}

interface AppState {
  showAntifrodModal: boolean;
  user: any;
  isOtp: boolean;
  isSpin: number;
  isAuth: boolean;
  isSwitchRouteLoading: boolean;
  checkResetPassword: boolean;
  changePasswordOtpState: boolean;
  otpLifeTime: number;
  otpType: string;
  isGoogleAuth: boolean;
  notificationModal: INotificationModalAttrs;
  requestInfoModal: boolean;
}

const initialState: AppState = {
  showAntifrodModal: false,
  user: {},
  isOtp: false,
  isSpin: 0,
  isAuth: false,
  isSwitchRouteLoading: true,
  checkResetPassword: false,
  changePasswordOtpState: false,
  otpLifeTime: 0,
  otpType: 'sms',
  isGoogleAuth: false,
  requestInfoModal: false,
  notificationModal: {
    isOpen: false,
    type: 'success',
    message: '',
    width: '400px',
  },
};

const app = createSlice({
  name: 'app',
  initialState,
  reducers: {
    showAntifrodModalAC(state, action: PayloadAction<boolean>) {
      state.showAntifrodModal = action.payload;
    },
    requestInfoModalAC(state, action: PayloadAction<boolean>) {
      state.requestInfoModal = action.payload;
    },
    otpTypeAC(state, action: PayloadAction<string>) {
      state.otpType = action.payload;
    },
    otpLifeTimeAC(state, action: PayloadAction<number>) {
      state.otpLifeTime = action.payload;
    },
    notificationModalAC(state, action: PayloadAction<INotificationModalAttrs>) {
      state.notificationModal = action.payload;
    },
    isSwitchRouteLoadingAC(state, action: PayloadAction<boolean>) {
      state.isSwitchRouteLoading = action.payload;
    },
    isAuthAC(state, action: PayloadAction<boolean>) {
      state.isAuth = action.payload;
    },
    isSpinAC(state, action: PayloadAction<boolean>) {
      if (action.payload) {
        state.isSpin += 1;
      } else if (state.isSpin > 0) {
        state.isSpin -= 1;
      } else {
        state.isSpin = 0;
      }
    },
    isOtpAC(state, action: PayloadAction<boolean>) {
      state.isOtp = action.payload;
    },
    userAC(state, action: PayloadAction<any>) {
      state.user = action.payload;
    },
    checkResetPasswordAC(state, action: PayloadAction<any>) {
      state.checkResetPassword = action.payload;
    },
    changePasswordOtpStateAC(state, action: PayloadAction<any>) {
      state.changePasswordOtpState = action.payload;
    },
    isGoogleAuthAC(state, action: PayloadAction<boolean>) {
      state.isGoogleAuth = action.payload;
    },
  },
});

export const {
  showAntifrodModalAC,
  requestInfoModalAC,
  otpTypeAC,
  isAuthAC,
  isSpinAC,
  isOtpAC,
  userAC,
  isSwitchRouteLoadingAC,
  checkResetPasswordAC,
  changePasswordOtpStateAC,
  notificationModalAC,
  otpLifeTimeAC,
  isGoogleAuthAC,
} = app.actions;
export default app.reducer;
